module.exports = __webpack_public_path__ + "img/ssh_Aechoterm/markSessionColor.gif";